/* diXed, rotes X in jedem Vorkommen der Wortmarke im Text.
   Angelegt am 29.08.2026.

   Grundregel: Steht "diXed" als Text auf der Seite, traegt das X Stempelrot.
   CSS kann einen einzelnen Buchstaben nicht einfaerben, es braucht ein
   Element darum. Dieses Skript setzt es.

   Es aendert nur Textknoten und legt dabei ein span an. Der Text selbst
   bleibt Zeichen fuer Zeichen derselbe. */
(function () {
  var UEBERSPRINGEN = {
    SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, INPUT: 1,
    SELECT: 1, OPTION: 1, CODE: 1, PRE: 1, SVG: 1, IFRAME: 1
  };
  /* Zwei Faelle, sonst nichts:
       diXed          das X in der Wortmarke
       dein X, Dein X das X als eigenes Wort im Markensatz

     Bewusst NICHT jedes einzelne X. Im Shop stehen auch "Meeting X",
     "X-Momente" und "das X die Unbekannte", in den Sprachdateien
     "X (Twitter)". Nichts davon meint die Marke. Deshalb der Blick nach
     hinten auf dein oder Dein und der Blick nach vorn, der Buchstaben,
     Ziffern und Bindestrich ausschliesst. */
  var MUSTER = /diXed|[Dd]ein[ \t\u00a0]+X(?![A-Za-z0-9\u00c0-\u024f_-])/g;

  function darfRein(knoten) {
    MUSTER.lastIndex = 0;
    if (!MUSTER.test(knoten.nodeValue)) return false;
    var p = knoten.parentNode;
    while (p && p.nodeType === 1) {
      if (UEBERSPRINGEN[p.tagName.toUpperCase()]) return false;
      if (p.className && String(p.className).indexOf('dixed-x') > -1) return false;
      p = p.parentNode;
    }
    return true;
  }

  function rotesX() {
    var x = document.createElement('span');
    x.className = 'dixed-x';
    x.textContent = 'X';
    return x;
  }

  function ersetzen(knoten) {
    var text = knoten.nodeValue;
    var stueck = document.createDocumentFragment();
    var letzte = 0;
    var t;
    MUSTER.lastIndex = 0;
    while ((t = MUSTER.exec(text))) {
      if (t.index > letzte) {
        stueck.appendChild(document.createTextNode(text.slice(letzte, t.index)));
      }
      /* Im Treffer wird nur das X eingefasst. Bei "diXed" bleibt di davor
         und ed dahinter, bei "dein X" nur das Wort davor. */
      var stelle = t[0].lastIndexOf('X');
      if (stelle > 0) {
        stueck.appendChild(document.createTextNode(t[0].slice(0, stelle)));
      }
      stueck.appendChild(rotesX());
      if (stelle + 1 < t[0].length) {
        stueck.appendChild(document.createTextNode(t[0].slice(stelle + 1)));
      }
      letzte = t.index + t[0].length;
    }
    if (letzte < text.length) {
      stueck.appendChild(document.createTextNode(text.slice(letzte)));
    }
    knoten.parentNode.replaceChild(stueck, knoten);
  }

  function lauf(wurzel) {
    if (!wurzel || wurzel.nodeType !== 1) return;
    var geher = document.createTreeWalker(wurzel, NodeFilter.SHOW_TEXT, null);
    var treffer = [];
    var n;
    while ((n = geher.nextNode())) {
      if (darfRein(n)) treffer.push(n);
    }
    /* Erst sammeln, dann ersetzen. Waehrend des Laufs zu aendern, wuerde den
       Geher aus dem Tritt bringen. */
    for (var i = 0; i < treffer.length; i++) ersetzen(treffer[i]);
  }

  function start() {
    lauf(document.body);
    /* Nachgeladenes von Apps mitnehmen. Die eingesetzten Knoten enthalten
       selbst kein "diXed" mehr, deshalb kann das nicht kreisen. */
    if (!window.MutationObserver) return;
    var offen = false;
    new MutationObserver(function (aenderungen) {
      if (offen) return;
      offen = true;
      requestAnimationFrame(function () {
        offen = false;
        for (var i = 0; i < aenderungen.length; i++) {
          var neue = aenderungen[i].addedNodes;
          for (var j = 0; j < neue.length; j++) lauf(neue[j]);
        }
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
